import React, {FC} from 'react';
import './style.scss';

//I added a bunch of CSS inline here to make sure the loading page looks
//good even if the CSS file hasn't finished loading yet
const LoadingScreen = ({hideAmpersand = false}) => (
  <div className="loading-screen">
    <AmpersandWhite text="Please wait..." hide={hideAmpersand}/>
  </div>
);

export const AmpersandWhite: FC<{ text: string, hide: boolean, noRepeat?: boolean }> = ({text, hide, noRepeat = false}) => {

  let className = "ampersand-loading-white";
  if (noRepeat) className += " no-repeat";

  return (
    <>
      <div className={className} style={hide ? {visibility: "hidden"} : undefined}>
        <svg
          version="1.1"
          width={230}
          height={240}
          viewBox="0 0 230 240"
          xmlSpace="preserve"
          className="svg-elem"
          id="svg32"
        >
          <g transform="matrix(13.35,0,0,13.35,-73.208331,119.27313)" id="g30">
            <g id="g28">
              <g transform="translate(13.93,-7.65)" id="Layer_1">
                <path
                  style={{
                    opacity: 1,
                    fill: "white",
                    fillRule: "nonzero",
                    stroke: "white",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-36.5,-1.16)"
                  d="m 35.6,2.29 c 0,0 -0.02,-0.06 -0.02,-0.06 -0.1,-0.37 -0.04,-0.72 0.16,-0.97 0.17,-0.22 0.43,-0.35 0.75,-0.38 0.07,0.16 0.23,0.26 0.41,0.26 h 0.72 c 0.25,0 0.45,-0.19 0.45,-0.44 V 0.46 c 0,-0.25 -0.2,-0.45 -0.45,-0.45 H 36.9 c -0.19,0 -0.35,0.11 -0.42,0.27 C 35.97,0.31 35.55,0.53 35.26,0.89 35,1.23 34.89,1.66 34.95,2.12 35.18,2.15 35.4,2.2 35.6,2.3 Z"
                  strokeLinecap="round"
                  id="path13"
                  className="svg-elem-1"
                />
              </g>
              <g transform="translate(13.25,0.01)" id="g18">
                <path
                  style={{
                    opacity: 1,
                    fill: "white",
                    fillRule: "nonzero",
                    stroke: "white",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-35.82,-8.82)"
                  d="M 38.463881,11.170461 C 38.903881,10.260461 39.26,9.62 39.59,9.22 c 1,-0.21 1.89,-1 2.16,-1.98 0.03,-0.1 1.48,-4.81 1.48,-4.81 C 43.38,1.87 43.29,1.34 42.99,0.94 42.71,0.57 42.29,0.35 41.78,0.31 41.71,0.15 41.55,0.03 41.37,0.03 h -0.72 c -0.25,0 -0.45,0.19 -0.45,0.44 v 0.24 c 0,0.25 0.2,0.45 0.45,0.45 h 0.72 c 0.18,0 0.34,-0.1 0.41,-0.25 0.32,0.04 0.58,0.17 0.74,0.39 0.19,0.25 0.24,0.6 0.14,0.97 0,0 -1.65,5.02 -1.68,5.14 -0.21,0.77 -1.14,1.16 -1.94,1.15 -0.8,0 -1.57,-0.45 -1.77,-1.23 -0.01,-0.04 -0.25,-0.77 -0.54,-1.66 -0.07,0.18 -0.16,0.35 -0.27,0.52 -0.07,0.1 -0.15,0.2 -0.23,0.3 0.12,0.4 0.2,0.68 0.2,0.7 0.24,0.93 1.04,1.7 1.97,1.97 0.08,0.15 0.13,0.33 0.13,0.53 0,0.35 -0.24,0.6 -0.44,1.11 -0.2,0.51 -0.56,1.23 -1.06,2.18 L 33.53,8.12 C 33.7,8 34.03,7.78 34.5,7.48 35.17,7.06 35.65,6.63 35.95,6.19 36.25,5.75 36.4,5.25 36.4,4.69 36.4,3.92 36.11,3.29 35.53,2.81 34.95,2.32 34.21,2.08 33.31,2.08 c -0.69,0 -1.28,0.14 -1.77,0.42 -0.49,0.28 -0.87,0.7 -1.12,1.24 -0.2,0.41 -0.3,0.83 -0.3,1.25 0,0.67 0.22,1.44 0.66,2.29 0.19,0.37 0.51,0.87 0.96,1.51 l -0.17,0.12 c -0.6,0.39 -1.07,0.73 -1.42,1.03 -0.34,0.29 -0.64,0.61 -0.89,0.94 -0.62,0.85 -0.93,1.79 -0.93,2.82 0,1.03 0.32,1.92 0.97,2.61 0.35,0.38 0.81,0.72 1.35,0.97 1.02,0.47 2.65,0.39 3.5,0 0.85,-0.39 1.11,-0.73 1.54,-1.2 0.2,-0.23 0.46,-0.58 0.78,-1.04 0.58,0.69 1.08,1.22 1.62,1.62 0.35,0.27 0.75,0.48 1.18,0.63 0.43,0.15 0.85,0.23 1.25,0.23 1.2,0 1.97,-0.62 2.34,-1.85 l -0.22,-0.1 c -0.16,0.39 -0.34,0.67 -0.55,0.85 -0.21,0.17 -0.47,0.26 -0.78,0.26 -0.29,0 -0.59,-0.09 -0.9,-0.26 -0.31,-0.17 -0.67,-0.44 -1.08,-0.82 -0.29,-0.27 -0.62,-0.61 -0.99,-1.03 -0.37,-0.42 -0.7,-0.81 -0.97,-1.17 0.35,-0.63 0.61,-1.14 0.79,-1.53 l 0.287485,-0.66499 z M 31.47,5.05 C 31.34,4.74 31.28,4.43 31.28,4.12 c 0,-0.52 0.16,-0.95 0.47,-1.27 0.31,-0.33 0.72,-0.49 1.22,-0.49 0.58,0 1.05,0.21 1.4,0.64 0.35,0.43 0.52,1 0.52,1.73 0,0.62 -0.13,1.19 -0.38,1.73 C 34.38,6.74 34.23,6.99 34.06,7.19 33.89,7.39 33.64,7.63 33.3,7.9 32.9,7.39 32.54,6.87 32.2,6.35 31.85,5.81 31.61,5.38 31.48,5.07 Z m 3.97,10.35 c -0.16,0.2 -0.34,0.37 -0.53,0.53 -0.53,0.42 -0.96,0.73 -1.64,0.77 -0.51,0.03 -0.88,0.01 -1.27,-0.17 -0.39,-0.18 -0.72,-0.43 -0.99,-0.76 -0.3,-0.36 -0.53,-0.8 -0.71,-1.33 -0.17,-0.52 -0.26,-1.06 -0.26,-1.62 0,-0.81 0.17,-1.55 0.5,-2.21 0.33,-0.66 0.8,-1.17 1.39,-1.54 l 4.1,5.45 c -0.24,0.38 -0.44,0.66 -0.6,0.86 z"
                  strokeLinecap="round"
                  id="path16"
                  className="svg-elem-2"
                />
              </g>
              <g transform="translate(20.9,5.5)" id="g22">
                <path
                  style={{
                    opacity: 1,
                    fill: "white",
                    fillRule: "nonzero",
                    stroke: "white",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-43.47,-14.3)"
                  d="m 43.47,15.97 c -0.92,0 -1.67,-0.75 -1.67,-1.67 0,-0.92 0.75,-1.67 1.67,-1.67 0.92,0 1.67,0.75 1.67,1.67 0,0.92 -0.75,1.67 -1.67,1.67 z m 0,-2.74 c -0.59,0 -1.06,0.48 -1.06,1.06 0,0.58 0.48,1.06 1.06,1.06 0.58,0 1.06,-0.48 1.06,-1.06 0,-0.58 -0.48,-1.06 -1.06,-1.06 z"
                  strokeLinecap="round"
                  id="path20"
                  className="svg-elem-3"
                />
              </g>
              <g transform="translate(20.9,5.5)" id="g26">
                <path
                  style={{
                    opacity: 1,
                    fill: "white",
                    fillRule: "nonzero",
                    stroke: "white",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-43.47,-14.3)"
                  d="m 43.47,15.01 c -0.39,0 -0.71,-0.32 -0.71,-0.71 0,-0.39 0.32,-0.71 0.71,-0.71 0.39,0 0.71,0.32 0.71,0.71 0,0.39 -0.32,0.71 -0.71,0.71 z m 0,-1.2 c -0.27,0 -0.49,0.22 -0.49,0.49 0,0.27 0.22,0.49 0.49,0.49 0.27,0 0.49,-0.22 0.49,-0.49 0,-0.27 -0.22,-0.49 -0.49,-0.49 z"
                  strokeLinecap="round"
                  id="path24"
                  className="svg-elem-4"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      {text ? <span className="center-text white-text mt-5">{text}</span> : null}
    </>
  )
}

export const AmpersandBlue: FC<{ text?: string, noRepeat?: boolean }> = ({text, noRepeat = false}) => {

  let className = "ampersand-loading-blue";
  if (noRepeat) className += " no-repeat";

  return (
    <>
      <div className={className}>
        <svg
          version="1.1"
          width={230}
          height={240}
          viewBox="0 0 230 240"
          xmlSpace="preserve"
          className="svg-elem"
          id="svg32"
        >
          <g transform="matrix(13.35,0,0,13.35,-73.208331,119.27313)" id="g30">
            <g id="g28">
              <g transform="translate(13.93,-7.65)" id="Layer_1">
                <path
                  style={{
                    opacity: 1,
                    fill: "#2693d1",
                    fillRule: "nonzero",
                    stroke: "#2693d1",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-36.5,-1.16)"
                  d="m 35.6,2.29 c 0,0 -0.02,-0.06 -0.02,-0.06 -0.1,-0.37 -0.04,-0.72 0.16,-0.97 0.17,-0.22 0.43,-0.35 0.75,-0.38 0.07,0.16 0.23,0.26 0.41,0.26 h 0.72 c 0.25,0 0.45,-0.19 0.45,-0.44 V 0.46 c 0,-0.25 -0.2,-0.45 -0.45,-0.45 H 36.9 c -0.19,0 -0.35,0.11 -0.42,0.27 C 35.97,0.31 35.55,0.53 35.26,0.89 35,1.23 34.89,1.66 34.95,2.12 35.18,2.15 35.4,2.2 35.6,2.3 Z"
                  strokeLinecap="round"
                  id="path13"
                  className="svg-elem-1"
                />
              </g>
              <g transform="translate(13.25,0.01)" id="g18">
                <path
                  style={{
                    opacity: 1,
                    fill: "#2693d1",
                    fillRule: "nonzero",
                    stroke: "#2693d1",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-35.82,-8.82)"
                  d="M 38.463881,11.170461 C 38.903881,10.260461 39.26,9.62 39.59,9.22 c 1,-0.21 1.89,-1 2.16,-1.98 0.03,-0.1 1.48,-4.81 1.48,-4.81 C 43.38,1.87 43.29,1.34 42.99,0.94 42.71,0.57 42.29,0.35 41.78,0.31 41.71,0.15 41.55,0.03 41.37,0.03 h -0.72 c -0.25,0 -0.45,0.19 -0.45,0.44 v 0.24 c 0,0.25 0.2,0.45 0.45,0.45 h 0.72 c 0.18,0 0.34,-0.1 0.41,-0.25 0.32,0.04 0.58,0.17 0.74,0.39 0.19,0.25 0.24,0.6 0.14,0.97 0,0 -1.65,5.02 -1.68,5.14 -0.21,0.77 -1.14,1.16 -1.94,1.15 -0.8,0 -1.57,-0.45 -1.77,-1.23 -0.01,-0.04 -0.25,-0.77 -0.54,-1.66 -0.07,0.18 -0.16,0.35 -0.27,0.52 -0.07,0.1 -0.15,0.2 -0.23,0.3 0.12,0.4 0.2,0.68 0.2,0.7 0.24,0.93 1.04,1.7 1.97,1.97 0.08,0.15 0.13,0.33 0.13,0.53 0,0.35 -0.24,0.6 -0.44,1.11 -0.2,0.51 -0.56,1.23 -1.06,2.18 L 33.53,8.12 C 33.7,8 34.03,7.78 34.5,7.48 35.17,7.06 35.65,6.63 35.95,6.19 36.25,5.75 36.4,5.25 36.4,4.69 36.4,3.92 36.11,3.29 35.53,2.81 34.95,2.32 34.21,2.08 33.31,2.08 c -0.69,0 -1.28,0.14 -1.77,0.42 -0.49,0.28 -0.87,0.7 -1.12,1.24 -0.2,0.41 -0.3,0.83 -0.3,1.25 0,0.67 0.22,1.44 0.66,2.29 0.19,0.37 0.51,0.87 0.96,1.51 l -0.17,0.12 c -0.6,0.39 -1.07,0.73 -1.42,1.03 -0.34,0.29 -0.64,0.61 -0.89,0.94 -0.62,0.85 -0.93,1.79 -0.93,2.82 0,1.03 0.32,1.92 0.97,2.61 0.35,0.38 0.81,0.72 1.35,0.97 1.02,0.47 2.65,0.39 3.5,0 0.85,-0.39 1.11,-0.73 1.54,-1.2 0.2,-0.23 0.46,-0.58 0.78,-1.04 0.58,0.69 1.08,1.22 1.62,1.62 0.35,0.27 0.75,0.48 1.18,0.63 0.43,0.15 0.85,0.23 1.25,0.23 1.2,0 1.97,-0.62 2.34,-1.85 l -0.22,-0.1 c -0.16,0.39 -0.34,0.67 -0.55,0.85 -0.21,0.17 -0.47,0.26 -0.78,0.26 -0.29,0 -0.59,-0.09 -0.9,-0.26 -0.31,-0.17 -0.67,-0.44 -1.08,-0.82 -0.29,-0.27 -0.62,-0.61 -0.99,-1.03 -0.37,-0.42 -0.7,-0.81 -0.97,-1.17 0.35,-0.63 0.61,-1.14 0.79,-1.53 l 0.287485,-0.66499 z M 31.47,5.05 C 31.34,4.74 31.28,4.43 31.28,4.12 c 0,-0.52 0.16,-0.95 0.47,-1.27 0.31,-0.33 0.72,-0.49 1.22,-0.49 0.58,0 1.05,0.21 1.4,0.64 0.35,0.43 0.52,1 0.52,1.73 0,0.62 -0.13,1.19 -0.38,1.73 C 34.38,6.74 34.23,6.99 34.06,7.19 33.89,7.39 33.64,7.63 33.3,7.9 32.9,7.39 32.54,6.87 32.2,6.35 31.85,5.81 31.61,5.38 31.48,5.07 Z m 3.97,10.35 c -0.16,0.2 -0.34,0.37 -0.53,0.53 -0.53,0.42 -0.96,0.73 -1.64,0.77 -0.51,0.03 -0.88,0.01 -1.27,-0.17 -0.39,-0.18 -0.72,-0.43 -0.99,-0.76 -0.3,-0.36 -0.53,-0.8 -0.71,-1.33 -0.17,-0.52 -0.26,-1.06 -0.26,-1.62 0,-0.81 0.17,-1.55 0.5,-2.21 0.33,-0.66 0.8,-1.17 1.39,-1.54 l 4.1,5.45 c -0.24,0.38 -0.44,0.66 -0.6,0.86 z"
                  strokeLinecap="round"
                  id="path16"
                  className="svg-elem-2"
                />
              </g>
              <g transform="translate(20.9,5.5)" id="g22">
                <path
                  style={{
                    opacity: 1,
                    fill: "#2693d1",
                    fillRule: "nonzero",
                    stroke: "#2693d1",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-43.47,-14.3)"
                  d="m 43.47,15.97 c -0.92,0 -1.67,-0.75 -1.67,-1.67 0,-0.92 0.75,-1.67 1.67,-1.67 0.92,0 1.67,0.75 1.67,1.67 0,0.92 -0.75,1.67 -1.67,1.67 z m 0,-2.74 c -0.59,0 -1.06,0.48 -1.06,1.06 0,0.58 0.48,1.06 1.06,1.06 0.58,0 1.06,-0.48 1.06,-1.06 0,-0.58 -0.48,-1.06 -1.06,-1.06 z"
                  strokeLinecap="round"
                  id="path20"
                  className="svg-elem-3"
                />
              </g>
              <g transform="translate(20.9,5.5)" id="g26">
                <path
                  style={{
                    opacity: 1,
                    fill: "#2693d1",
                    fillRule: "nonzero",
                    stroke: "#2693d1",
                    strokeWidth: "0.1",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 4
                  }}
                  transform="translate(-43.47,-14.3)"
                  d="m 43.47,15.01 c -0.39,0 -0.71,-0.32 -0.71,-0.71 0,-0.39 0.32,-0.71 0.71,-0.71 0.39,0 0.71,0.32 0.71,0.71 0,0.39 -0.32,0.71 -0.71,0.71 z m 0,-1.2 c -0.27,0 -0.49,0.22 -0.49,0.49 0,0.27 0.22,0.49 0.49,0.49 0.27,0 0.49,-0.22 0.49,-0.49 0,-0.27 -0.22,-0.49 -0.49,-0.49 z"
                  strokeLinecap="round"
                  id="path24"
                  className="svg-elem-4"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      {text && <span className="center-text primary-text mt-5">{text}</span>}
    </>
  )
}

export default LoadingScreen;
